const apiUrl = "https://admin.alt-opel-schweiz.ch";

export { apiUrl };
